<template>
  <fragment>
    <v-row class="mt-2">
      <v-col cols="12">
        <v-autocomplete
          v-model="user.address.country_id"
          :items="countries"
          :rules="[(v) => !!v || 'Ülke alanı boş bırakılamaz']"
          autocomplete=" off"
          hide-details="auto"
          item-text="text"
          item-value="value"
          label="Ülke"
          required
        />
      </v-col>
    </v-row>
    <fragment v-if="user.address.country_id === 222">
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="user.address.city_id"
            :items="cities"
            :rules="[(v) => !!v || 'İl alanı boş bırakılamaz']"
            autocomplete=" off"
            hide-details="auto"
            item-text="text"
            item-value="value"
            label="İl"
            required
            @change="getDistricts($event)"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="user.address.district_id"
            :items="districts"
            :loading="citiesLoading"
            :rules="[(v) => !!v || 'İlçe alanı boş bırakılamaz']"
            autocomplete=" off"
            hide-details="auto"
            item-text="text"
            item-value="value"
            label="İlçe"
            required
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="user.address.neighborhood"
            :rules="[(v) => !!v || 'Mahalle alanı boş bırakılamaz']"
            autocomplete=" off"
            hide-details="auto"
            label="Mahalle"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="user.address.street"
            :rules="[(v) => !!v || 'Sokak alanı boş bırakılamaz']"
            autocomplete=" off"
            hide-details="auto"
            label="Cadde - Sokak"
            required
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="user.address.building"
            :rules="[(v) => !!v || 'Bina numarası alanı boş bırakılamaz']"
            autocomplete=" off"
            hide-details="auto"
            label="Bina Numarası"
            required
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="user.address.door"
            :rules="[(v) => !!v || 'Kapı numarası alanı boş bırakılamaz']"
            autocomplete=" off"
            hide-details="auto"
            label="Kapı Numarası"
            required
          />
        </v-col>
      </v-row>
    </fragment>
    <fragment v-else>
      <v-text-field
        v-model="user.address.address_line"
        :rules="[(v) => !!v || 'Açık adres alanı boş bırakılamaz']"
        class="mt-6"
        hide-details="auto"
        label="Açık Adres"
        required
      />
    </fragment>
  </fragment>
</template>

<script>
import AxiosInstance from "@/core/services/axios.service";

export default {
  name: "Address",
  props: {
    user: {
      type: Object,
    },
    isFormValid: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: "user",
    event: "update:user",
  },
  mounted() {
    this.getCountries().then((countries) => {
      this.countries = countries;
      this.user.address.country_id = this.user.address.country_id || 222;
    });
    this.getCities().then((cities) => {
      this.cities = cities;
      this.user.address.city_id = this.user.address.city_id || null;
      if (this.user.address.city_id) {
        this.getDistricts(this.user.address.city_id).then((districts) => {
          this.districts = districts;
          this.user.address.district_id = this.user.address.district_id || null;
        });
      }
    });
  },
  data() {
    return {
      countries: [],
      cities: [],
      districts: [],
      citiesLoading: false,
    };
  },
  methods: {
    getCountries() {
      return new Promise((resolve) => {
        AxiosInstance.get("/locations/countries").then((response) => {
          resolve(
            response.data.map((country) => {
              return {
                text: country.name,
                value: country.id,
                code: country.code,
              };
            })
          );
        });
      });
    },
    getCities() {
      return new Promise((resolve) => {
        AxiosInstance.get("/locations/cities").then((response) => {
          resolve(
            response.data.map((city) => {
              return {
                text: city.name,
                value: city.id,
                key: city.city_key,
              };
            })
          );
        });
      });
    },
    getDistricts(city_id) {
      this.citiesLoading = true;
      const city = this.cities.find((city) => city.value === city_id);
      return new Promise((resolve) => {
        AxiosInstance.get(`/locations/districts/${city.key}`)
          .then((response) => {
            const result = response.data.map((district) => {
              return {
                text: district.name,
                value: district.id,
              };
            });
            this.districts = result;
            resolve(result);
          })
          .finally(() => {
            this.citiesLoading = false;
          });
      });
    },
  },
  watch: {
    user: {
      handler: function (val) {
        this.$emit("update:user", val);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
h2,
p {
  display: inline-block;
  margin: 0;
  padding: 0;
}
p {
  color: #ff5252;
  font-style: italic;
}
</style>
